import React from "react";
import { siteConfig } from "../mock";

const Footer = () => {
  return (
    <footer className="w-full bg-black border-t border-white/10">
      <div className="max-w-[1240px] mx-auto px-6 py-8 text-center">
        <p
          className="text-white/70 text-sm"
          style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
        >
          © {new Date().getFullYear()} {siteConfig.brandName}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
